export default (currentScrollHeight) => {
  const targets = document.querySelectorAll('.js-target')
  const menuButtons = document.querySelectorAll('.js-page-scroll-button')
  let currentTraget
  let currentButton
  if(targets.length){
    ;[...targets].forEach(target => {
      if(target.offsetTop <= currentScrollHeight + 200 && target.offsetTop > (currentScrollHeight - window.innerHeight)){
        currentTraget = target.getAttribute('data-id')
        ;[...menuButtons].forEach(menuButton => {
          currentButton = menuButton.getAttribute('data-target-id')
          const currentButtonClean = currentButton.substring(currentButton.lastIndexOf('#') + 1);
          if(currentTraget == currentButtonClean && !menuButton.classList.contains('active')){
            clearAllActive(menuButtons)
            setActive(menuButton)
          }
        })
      }
    })
  }
  else{
    const url = window.location.href;
    const idFromUrl = url.split('/')
    const currentPage = idFromUrl[idFromUrl.length-2]
    ;[...menuButtons].forEach(menuButton => {
      currentButton = menuButton.getAttribute('data-target-id')
      const currentButtonCleanArray = currentButton.split('/')
      const currentButtonClean = currentButtonCleanArray[currentButtonCleanArray.length-2]
      if(currentPage == currentButtonClean && !menuButton.classList.contains('active')){
        clearAllActive(menuButtons)
        setActive(menuButton)
      }
    })
  }
}
function clearAllActive(menuButtons) {
  ;[...menuButtons].forEach(menuButton => {
    if(menuButton.classList.contains('active')){
      menuButton.classList.remove('active')
    }
  })
}
function setActive(menuButton) {
  menuButton.classList.add('active')
}


// WEBPACK FOOTER //
// ./src/js/modules/onScrollEffects/MenuActive.js